// Supplier administration keeps the complete list; new purchases only use eligible suppliers.
export const isActivePurchaseSupplier = (supplier) => Boolean(supplier) &&
  supplier.is_active !== false && supplier.is_stock_supplier !== false;

export const activePurchaseSuppliers = (suppliers) =>
  (Array.isArray(suppliers) ? suppliers : []).filter(isActivePurchaseSupplier);
